<template>
  <v-app id="user_app" class="teal darken-4">
    <notification />

    <router-view />
  </v-app>
</template>

<script>
import Notification from '@/components/layout/Notification';
import { isMobile } from '@/utils/regex';
import { LocalStorage } from './enums/storage.enum';

// @vuese
// App
// @group App
export default {
  components: { Notification },
  mounted() {
    if (isMobile() && !localStorage.getItem(LocalStorage.PWA_POPUP)) {
      this.$store.commit('system/showPopup');
    }
  }
};
</script>

<style src="./styles/styles.scss" lang="scss" />
